import { render, staticRenderFns } from "./MainColorPicker.vue?vue&type=template&id=23c24a50"
import script from "./MainColorPicker.vue?vue&type=script&lang=js"
export * from "./MainColorPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports